<a-side :sub-menu="true" v-if="!!purchase">
    <ul class="aside-navigation">
        <li>
            <router-link :to="{name: 'shop'}" :title="$t('vm.root.shop.purchase.aside.back.label')"
                v-toggle="{className: 'is-open', reducer: '[data-toggle-aside]'}">
                <svg width="1em" class="svg-middle" viewBox="0 0 448 512" aria-hidden="true">
                    <use xlink:href="@Assets/svg/symbol-defs.svg#arrow-left"/>
                </svg>
                {{ $t('vm.root.shop.purchase.aside.back.label') }}
            </router-link>
        </li>
        <li class="hr" aria-hidden="true"/>
    </ul>
    <ul class="aside-navigation is-pushed-down" v-if="!isCompleted">
        <li class="hr" aria-hidden="true"/>
        <li>
            <delete-item :delete-action="submitDelete" :can-delete="true" :disabled="isDeleting"
                v-toggle="{className: 'is-open', reducer: '[data-toggle-aside]'}"
                :title="$t('vm.root.shop.purchase.aside.delete.title')"
                :delete-msg="$t('vm.root.shop.purchase.aside.delete.delete-msg')">
                <spinner v-if="isDeleting"/>
                <svg v-else width="1em" class="svg-middle" viewBox="0 0 448 512" aria-hidden="true" focusable="false">
                    <use xlink:href="@Assets/svg/symbol-defs.svg#trash-alt"/>
                </svg>
                {{ $t('vm.root.shop.purchase.aside.delete.label') }}
            </delete-item>
        </li>
    </ul>
</a-side>
